// extracted by mini-css-extract-plugin
export default {"root":"IconHairDryer_root__lKjMg"};